import apiService from '../apiService';

/**
 * 取得取消申請列表
 * @param {Object} params - 查詢參數
 * @param {string} params.status - 申請狀態（pending, approved, rejected）
 * @param {string} params.refund_status - 退款狀態（none, pending, processing, completed, failed）
 * @param {string} params.order_no - 訂單編號（模糊搜尋）
 * @param {string} params.from - 開始日期（格式：YYYY-MM-DD）
 * @param {string} params.to - 結束日期（格式：YYYY-MM-DD）
 * @param {number} params.per_page - 每頁筆數，預設 15
 * @param {number} params.page - 頁碼
 * @returns {Promise} API 響應
 */
export const getCancellationRequests = async (params = {}) => {
    const url = '/api/admin/order-cancellation-requests';
    return apiService.GET(url, params);
};

/**
 * 取得取消申請詳情
 * @param {number} id - 取消申請 ID
 * @returns {Promise} API 響應
 */
export const getCancellationRequest = async (id) => {
    const url = `/api/admin/order-cancellation-requests/${id}`;
    return apiService.GET(url);
};

/**
 * 核准取消申請
 * @param {number} id - 取消申請 ID
 * @param {Object} data - 審核資料
 * @param {string} data.note - 審核備註（選填）
 * @returns {Promise} API 響應
 */
export const approveCancellationRequest = async (id, data = {}) => {
    const url = `/api/admin/order-cancellation-requests/${id}/approve`;
    return apiService.POST(url, data);
};

/**
 * 拒絕取消申請
 * @param {number} id - 取消申請 ID
 * @param {Object} data - 審核資料
 * @param {string} data.note - 拒絕原因（必填，最多 500 字）
 * @returns {Promise} API 響應
 */
export const rejectCancellationRequest = async (id, data) => {
    const url = `/api/admin/order-cancellation-requests/${id}/reject`;
    return apiService.POST(url, data);
};

/**
 * 重試退款
 * @param {number} id - 取消申請 ID
 * @returns {Promise} API 響應
 */
export const retryRefund = async (id) => {
    const url = `/api/admin/order-cancellation-requests/${id}/retry-refund`;
    return apiService.POST(url);
};
